var map = {
	"./arrow-left.svg": 4720,
	"./check.svg": 7325,
	"./chevron-down.svg": 7164,
	"./chevron-right.svg": 9193,
	"./chevron-up.svg": 3475,
	"./menu.svg": 9749,
	"./qr_placeholder.svg": 8033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;